import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { X } from 'lucide-react';

const AddDeviceModal = ({ newDevice, setNewDevice, handleAddDevice, addingDevice, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-bold">Add New Device</h3>
        <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="space-y-4">
        <div>
          <Label htmlFor="deviceName">Device Name *</Label>
          <Input id="deviceName" placeholder="e.g., Server-02" value={newDevice.name} onChange={(e) => setNewDevice({ ...newDevice, name: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="deviceType">Device Type</Label>
          <select id="deviceType" className="w-full px-3 py-2 border rounded-md" value={newDevice.type} onChange={(e) => setNewDevice({ ...newDevice, type: e.target.value })}>
            <option value="server">Server</option>
            <option value="router">Router</option>
            <option value="workstation">Workstation</option>
            <option value="iot">IoT Device</option>
            <option value="automotive">Automotive</option>
            <option value="cctv">CCTV Camera</option>
            <option value="white_goods">White Goods (IoT)</option>
          </select>
        </div>
        <div>
          <Label htmlFor="deviceIP">IP Address *</Label>
          <Input id="deviceIP" placeholder="e.g., 192.168.1.100" value={newDevice.ip} onChange={(e) => setNewDevice({ ...newDevice, ip: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="deviceOS">Operating System</Label>
          <Input id="deviceOS" placeholder="e.g., Ubuntu 22.04" value={newDevice.os} onChange={(e) => setNewDevice({ ...newDevice, os: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="segment">Security Segment</Label>
          <select id="segment" className="w-full px-3 py-2 border rounded-md" value={newDevice.segment} onChange={(e) => setNewDevice({ ...newDevice, segment: e.target.value })}>
            <option value="enterprise">Enterprise</option>
            <option value="telco">Telco</option>
            <option value="mobile">Mobile</option>
            <option value="automotive">Automotive</option>
            <option value="white_goods">White Goods</option>
            <option value="cctv">CCTV</option>
          </select>
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <Button variant="outline" className="flex-1" onClick={onClose}>Cancel</Button>
        <Button className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600" onClick={handleAddDevice} disabled={addingDevice}>
          {addingDevice ? 'Adding...' : 'Add Device'}
        </Button>
      </div>
    </div>
  </div>
);

export default AddDeviceModal;
